export default {"src":"/_next/static/media/shopping-bag.428a38a6.svg","height":138,"width":115};